const state = {
  listaVinculosDocumento: [],
  documentoAgregador: undefined
}

export default state
